<template>
  <div>
    <el-card shadow="always">
      <el-page-header @back="back" title :content="$t('adicionar-nova-reclamacao')"></el-page-header>
    </el-card>
    <el-card>
      <el-form :model="ruleForm" label-position="top">
        <el-row :gutter="5">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-if="user.type !== '5'">
            <el-form-item :label="user.type === '1' || user.type === '3' ? $t('cliente') : $t('filial')" prop="customer">
              <CustomerList v-model="ruleForm.customer" v-bind:customerType="user.type === '2' ? 3 : 1"
                v-bind:current="ruleForm.customer" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('motivo')" prop="reason">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <RequestInfoReasonList v-model="ruleForm.reason" :current="ruleForm.reason" />
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('nome')" prop="name">
          <el-input ref="name" v-model="ruleForm.name" maxlength="80"></el-input>
        </el-form-item>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-if="user.type !== '5'">
            <el-form-item :label="$t('etiqueta')" prop="tag">
              <el-input ref="tag" v-model="ruleForm.tag" maxlength="13"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <br />
        <el-form-item>
          <el-button type="warning" autofocus @click="save">{{ $t("adicionar") }}</el-button>
          <el-button @click="back()">{{ $t("voltar") }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { UserService } from "@/services/users/user.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import RequestInfoReasonList from './RequestInfoReasonList.vue';
import { RequestInfoService } from "@/services/customers/request.info.services";

export default {
  name: "RequestInfo",
  components: {
    RequestInfoReasonList,
    CustomerList,
  },
  data() {
    return {
      ruleForm: {
        reason: "",
        customer: "",
        name: "",
        tag: "",
      },
      user: {
        type: "1",
        name: "",
      },
    };
  },
  methods: {
    back() {
      this.$router.push({ name: 'request.info' });
    },
    save() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);

      RequestInfoService.add(vm.ruleForm)
        .then((response) => {
          console.log(response)
          if (response.errorMessage) {
            return this.$message({ type: "error", duration: 5000, message: response.errorMessage });
          }
          this.$message({
            type: "success",
            message: `Reclamação adicionada com sucesso!`,
          });
        })
        .catch((error) => {
          this.$message({ type: "error", duration: 5000, message: error });
        })
        .finally(() => loading.close());
    }
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        vm.ruleForm.name = response.name;
        vm.ruleForm.tag = vm.$route.params.tag || "";
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>

<style>
.el-drawer__body {
  overflow-y: auto !important;
}
</style>